import styled from "styled-components";

export const CommitmentBreakdownWrapper = styled.div`
  display: grid;
  gap: 32px 128px;
  grid-template-columns: 1fr;
  justify-content: space-between;

  @media (min-width: 1031px) {
    grid-template-columns: repeat(2, minmax(min-content, 700px));
  }
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  p {
    margin: 0;
  }

  & > * {
    flex-shrink: 0;
  }
`;

export const Separator = styled.hr`
  width: 100%;
  background-color: var(
    --divider-periwinkle-grey-background-color,
    var(--periwinkle-grey)
  );
  margin: 0;
  flex-shrink: 1;
  position: relative;
  top: 50%;
`;
